import { createRouter, createWebHistory, } from "vue-router";
import { useAuthStore } from "@/store/authStore";
const routes = [
    {
        path: "/",
        name: "root",
        redirect: () => {
            const auth = useAuthStore();
            return auth.sessionIsValidNow() ? "/app" : "/login";
        },
    },
    {
        path: "/login",
        name: "login",
        meta: { public: true, pageTitle: "Ingresar" },
        component: () => import("@/views/auth/LoginPage.vue"),
    },
    {
        path: "/app",
        meta: { requiresAuth: true },
        component: () => import("@/layouts/MainLayout.vue"),
        children: [
            {
                path: "",
                name: "app-home",
                meta: { pageTitle: "Inicio" },
                component: () => import("@/views/app/HomeDashboardView.vue"),
            },
            {
                path: "integradores",
                name: "app-integradores",
                meta: {
                    pageTitle: "Integradores",
                    roles: ["ADMINISTRADOR"],
                },
                component: () => import("@/views/app/IntegradoresView.vue"),
            },
            {
                path: "usuarios",
                name: "app-usuarios",
                meta: {
                    pageTitle: "Usuarios",
                    roles: ["ADMINISTRADOR"],
                },
                component: () => import("@/views/app/UsuariosView.vue"),
            },
            {
                path: "solicitudes",
                name: "app-solicitudes",
                meta: { pageTitle: "Solicitudes" },
                component: () => import("@/views/app/SolicitudesView.vue"),
            },
            {
                path: "solicitudes/nueva",
                name: "app-solicitud-nueva",
                meta: { pageTitle: "Nueva solicitud" },
                component: () => import("@/views/app/NuevaSolicitudView.vue"),
            },
            {
                path: "solicitudes/:id",
                name: "app-solicitud-detalle",
                meta: { pageTitle: "Detalle solicitud" },
                component: () => import("@/views/app/SolicitudDetalleView.vue"),
            },
            {
                path: "certificaciones",
                name: "app-certificaciones",
                meta: {
                    pageTitle: "Certificaciones",
                    roles: ["ADMINISTRADOR", "CERTIFICADOR"],
                },
                component: () => import("@/views/app/CertificacionesView.vue"),
            },
            {
                path: "certificaciones/:id",
                name: "app-certificacion-detalle",
                meta: {
                    pageTitle: "Detalle certificación",
                    roles: ["ADMINISTRADOR", "CERTIFICADOR"],
                },
                component: () => import("@/views/app/CertificacionDetalleView.vue"),
            },
            {
                path: "portal",
                name: "app-portal",
                meta: {
                    pageTitle: "Portal integrador",
                    roles: ["INTEGRADOR", "ADMINISTRADOR"],
                },
                component: () => import("@/views/app/PortalIntegradorView.vue"),
            },
            {
                path: "reportes",
                name: "app-reportes",
                meta: {
                    pageTitle: "Reportes",
                    roles: ["ADMINISTRADOR"],
                },
                component: () => import("@/views/app/ReportesView.vue"),
            },
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        redirect: "/",
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes,
});
const isExplicitlyPublicRoute = (route) => route.matched.some((record) => record.meta.public === true);
router.beforeEach(async (to, _from, next) => {
    const auth = useAuthStore();
    if (to.name === "root") {
        next();
        return;
    }
    if (isExplicitlyPublicRoute(to)) {
        if (auth.sessionIsValidNow() && to.name === "login") {
            const redirectTarget = typeof to.query.redirect === "string" && to.query.redirect
                ? to.query.redirect
                : "/app";
            next({ path: redirectTarget });
            return;
        }
        next();
        return;
    }
    if (!auth.sessionIsValidNow()) {
        await auth.clearSession();
        next({ name: "login", query: { redirect: to.fullPath } });
        return;
    }
    const roles = to.meta.roles;
    if (roles && roles.length > 0 && !roles.includes(auth.perfil)) {
        next({ name: "app-home" });
        return;
    }
    next();
});
router.afterEach((to) => {
    if (to.name !== "login") {
        localStorage.setItem("lastRoute", to.fullPath);
    }
});
export default router;
